let _enabled = null;
let _seq = 0;

function isEnabled() {
  if (_enabled !== null) return _enabled;
  try {
    _enabled = localStorage.getItem("w86_stream_debug") === "1";
  } catch {
    _enabled = false;
  }
  return _enabled;
}

function seq() {
  return ++_seq;
}

function ts() {
  return new Date().toISOString().slice(11, 23);
}

function summarizeMessages(messages) {
  if (!Array.isArray(messages)) return "null";
  return messages.map((m, i) => {
    const id = m.messageId || m.id || "?";
    const role = m.role || "?";
    const opt = m._optimistic ? " [OPT]" : "";
    const status = m.status ? ` (${m.status})` : "";
    const partsCount = Array.isArray(m.parts) ? ` parts=${m.parts.length}` : "";
    const contentSnip = m.content ? ` "${m.content.slice(0, 40)}${m.content.length > 40 ? "..." : ""}"` : "";
    return `  [${i}] ${role}${opt}${status} id=${id}${partsCount}${contentSnip}`;
  }).join("\n");
}

function summarizeParts(parts) {
  if (!Array.isArray(parts)) return "none";
  return parts.map((p, i) => {
    if (p.type === "text") {
      const len = (p.text || "").length;
      return `[${i}] text state=${p.state} len=${len}`;
    }
    if (p.type === "tool") {
      return `[${i}] tool=${p.toolName} callId=${p.toolCallId} state=${p.state}`;
    }
    return `[${i}] ${p.type || "unknown"}`;
  }).join(", ");
}

function diffMessages(label, before, after) {
  if (!isEnabled()) return;
  const beforeIds = new Set((before || []).map(m => m.messageId || m.id || "?"));
  const afterIds = new Set((after || []).map(m => m.messageId || m.id || "?"));
  const added = [...afterIds].filter(id => !beforeIds.has(id));
  const removed = [...beforeIds].filter(id => !afterIds.has(id));
  if (added.length || removed.length || (before || []).length !== (after || []).length) {
    console.log(
      `%c[W86:${label}] messages diff: ${(before || []).length} → ${(after || []).length} | +[${added.join(",")}] -[${removed.join(",")}]`,
      "color: #e67e22; font-weight: bold"
    );
  }
}

const LAYER_COLORS = {
  SSE: "#3498db",
  Transport: "#2ecc71",
  StreamStore: "#9b59b6",
  AgentStore: "#e74c3c",
  Chunks: "#f39c12",
  Render: "#1abc9c",
  Send: "#e91e63",
};

function log(layer, message, data) {
  if (!isEnabled()) return;
  const color = LAYER_COLORS[layer] || "#95a5a6";
  const n = seq();
  const prefix = `[W86:${layer}] #${n} ${ts()}`;
  if (data !== undefined) {
    console.log(`%c${prefix} ${message}`, `color: ${color}; font-weight: bold`, data);
  } else {
    console.log(`%c${prefix} ${message}`, `color: ${color}; font-weight: bold`);
  }
}

function logGroup(layer, message, fn) {
  if (!isEnabled()) return;
  const color = LAYER_COLORS[layer] || "#95a5a6";
  const n = seq();
  const prefix = `[W86:${layer}] #${n} ${ts()}`;
  console.groupCollapsed(`%c${prefix} ${message}`, `color: ${color}; font-weight: bold`);
  try {
    fn();
  } finally {
    console.groupEnd();
  }
}

function enable() {
  _enabled = true;
  _seq = 0;
  try { localStorage.setItem("w86_stream_debug", "1"); } catch {}
  console.log("%c[W86] Stream debug logging ENABLED. Reload to apply everywhere. Call w86debug.disable() to turn off.", "color: #2ecc71; font-weight: bold; font-size: 14px");
}

function disable() {
  _enabled = false;
  _seq = 0;
  try { localStorage.removeItem("w86_stream_debug"); } catch {}
  console.log("%c[W86] Stream debug logging DISABLED.", "color: #e74c3c; font-weight: bold; font-size: 14px");
}

function status() {
  console.log(`[W86] debug=${isEnabled()}, seq=${_seq}`);
}

if (typeof window !== "undefined") {
  window.w86debug = { enable, disable, status, seq: () => _seq };
}

export {
  isEnabled,
  log,
  logGroup,
  summarizeMessages,
  summarizeParts,
  diffMessages,
  enable,
  disable,
};
